
        <fieldmagic-primary-button
          variant="success"
          (click)="onUpload()"
          [isInProgress]="uploading$ | async"
          [purpose]="purpose">
        </fieldmagic-primary-button>